<template>
  <button
    @click="printPage"
    class="px-4 py-2 bg-blue-600 text-white rounded shadow"
  >
    Imprimir
  </button>
</template>

<script>
export default {
  methods: {
    printPage() {
      window.print()
    },
  },
}
</script>

<style scoped>
button:active {
  transform: scale(0.98);
}

button:hover {
  background-color: #2c67dc;
}
</style>
